import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';
import { DeliveryFilterDTO, DeliveryFilterOptionsDTO, DeliveryService } from '../generated';

export const deliveryFilterOptionKeys = {
  base: ['deliveryFilterOptions'] as const,
  list: ({ jobsiteId, filter }: DeliveryFilterOptionsProps) =>
    [...deliveryFilterOptionKeys.base, 'list', jobsiteId, filter] as const,
};

export interface DeliveryFilterOptionsProps {
  jobsiteId: string | undefined;
  filter: DeliveryFilterDTO | undefined;
}

export function deliveryFilterOptions({ jobsiteId, filter }: DeliveryFilterOptionsProps) {
  // Skip updating options from the API if more than one filter is selected
  const filterItemCount = Object.keys(filter || {}).length;
  const isEnabled = !!jobsiteId && filterItemCount <= 1;

  return queryOptions({
    queryKey: deliveryFilterOptionKeys.list({ jobsiteId, filter }),
    queryFn: async (): Promise<DeliveryFilterOptionsDTO> => {
      const response = await DeliveryService.deliveryControllerGetFilterOptions({
        path: { jobsiteId: jobsiteId || '' },
        query: { filter: [filter || {}] },
      });

      if (response.data !== undefined) {
        return response.data;
      } else {
        throw (response as any).error || new Error(response.response?.statusText || 'Unknown error');
      }
    },
    enabled: isEnabled,
    placeholderData: keepPreviousData,
  });
}

export function useDeliveryFilterOptions(props: DeliveryFilterOptionsProps) {
  return useQuery(deliveryFilterOptions(props));
}
